export const links = {
  email: "kasireddy.y@northeastern.edu",
  linkedin: "https://www.linkedin.com/in/yoga-srinivas-reddy-kasireddy-38b8151a0/",
  github: "https://github.com/Srinivas142000",
  resume: "https://drive.google.com/file/d/17Wcf02A2cashal6m9t_7lvViUZo1cArK/view?usp=drive_link",
};

// Each role types out in its own color
export const roles = [
  { text: "Tech Enthusiast", color: "#FF6347" },
  { text: "Avid Reader", color: "#FFD700" },
  { text: "Software Engineer", color: "#32CD32" },
  { text: "Student", color: "#00CED1" },
  { text: "Geek", color: "#FF1493" },
  { text: "Software Developer", color: "#B266FF" },
  { text: "Forever Curious", color: "#00FA9A" },
];

export const skillGroups = [
  {
    name: "Languages",
    items: ["Python", "Java", "JavaScript", "TypeScript", "Go", "C++", "C", "Swift", "Kotlin", "MATLAB"],
  },
  { name: "Frontend", items: ["React", "Angular", "Vue"] },
  {
    name: "Backend & Data",
    items: ["Node.js", "Spring Boot", "PostgreSQL", "MongoDB", "Redis", "PySpark"],
  },
  { name: "Cloud & Tools", items: ["AWS", "Docker", "GitHub", "Jupyter"] },
  { name: "ML & Mobile", items: ["TensorFlow", "iOS SDK", "Android SDK", "React Native"] },
];

// Newest first
export const timeline = [
  {
    type: "education",
    date: "Jan 2025 – Present",
    title: "MS in Financial Engineering",
    org: "WorldQuant University",
    description: "Pursuing a Master of Science in Financial Engineering.",
  },
  {
    type: "education",
    date: "Sep 2024 – Present",
    title: "MS in Computer Science (Scholarship)",
    org: "Northeastern University",
    description:
      "GPA 4.0/4.0. Relevant coursework includes Programming Design Paradigm and Algorithms.",
  },
  {
    type: "work",
    date: "Jun 2022 – Aug 2024",
    title: "Development Engineer 1",
    org: "Comcast",
    description:
      "Developed algorithms for processing large-scale network data, managed critical data workflows, and automated customer transitions during database updates.",
  },
  {
    type: "education",
    date: "Jul 2022",
    title: "B.Tech in Computer Science & Engineering",
    org: "SASTRA University",
    description: "Graduated First Class with Distinction.",
  },
  {
    type: "work",
    date: "Jan 2022 – Jun 2022",
    title: "Software Engineering Intern",
    org: "Comcast",
    description:
      "Integrated GitHub and JIRA, developed AR solutions, and contributed to customer-facing projects.",
  },
];

export const stats = [
  { value: "2+", label: "Years of industry experience", icon: "briefcase" },
  { value: "3", label: "Hackathon wins", icon: "trophy" },
  { value: "5", label: "Work awards", icon: "award" },
  { value: "10", label: "Certificates & licenses", icon: "patch" },
  { value: "1", label: "Scholarship", icon: "mortarboard" },
];
